module.exports = __webpack_public_path__ + "img/crazy__people.9c977672.svg";